import styled from 'styled-components';

export const ButtonMenuStyled = styled.button`
  border: none;
  height: 46px;

  display: flex;
  flex-direction: row;
  align-items: center;

  font-size: 16px;
  font-family: Source Sans Pro;
  text-align: left;
  padding: 0;
  background-color: ${(props) =>
    props.selected ? '#013CDB1A' : 'var(--color-white)'};
  color: var(--color-gray-100);

  border-left: ${(props) => (props.selected ? '3px solid blue' : 'none')};

  :first-child {
    margin-top: 40px;
  }

  div {
    width: 100%;
    display: flex;
    align-items: center;
    height: 25px;
    margin-left: 26px;
    cursor: pointer;
  }

  span {
    margin-left: 13px;
    cursor: pointer;
  }
`;
